import React from "react";

const portrait = "/photos/temp.jpg";

const About = () => {
  return (
    <div className="min-h-screen relative flex items-center justify-center px-4 sm:px-6 py-20 sm:py-24 bg-black text-[#f0eae2] overflow-hidden">
      {/* Background blur layer */}
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{
          backgroundImage: `url(${portrait})`,
          filter: "blur(12px) brightness(0.4)",
        }}
      />

      {/* Glass Card */}
      <div className="relative z-10 w-full max-w-5xl rounded-[28px] sm:rounded-[30px] bg-gradient-to-br from-white/10 via-white/5 to-white/10 border border-white/20 backdrop-blur-[18px] shadow-[0_8px_40px_rgba(0,0,0,0.4)] p-6 sm:p-10 md:p-14 flex flex-col md:flex-row gap-8 sm:gap-10">
        {/* Reflection layers */}
        <div className="absolute top-0 left-0 w-full h-[90px] sm:h-[110px] bg-white/10 rounded-t-[28px] sm:rounded-t-[30px] blur-[40px] pointer-events-none z-10" />
        <div className="absolute bottom-0 left-0 w-full h-20 sm:h-24 bg-gradient-to-t from-black/20 to-transparent z-10 pointer-events-none rounded-b-[28px] sm:rounded-b-[30px]" />

        {/* Portrait */}
        <div className="w-full md:w-1/2 relative z-20">
          <img
            src={portrait}
            alt="Portrait of Elijah"
            className="rounded-2xl border border-white/20 shadow-lg w-full max-h-[360px] sm:max-h-[400px] object-cover"
            loading="eager"
          />
          <p className="text-center text-[#c2a86e] text-xs sm:text-sm italic mt-4 tracking-wide">
            She said, “Shoot me, Eli.” So I did.
          </p>
        </div>

        {/* Text Section */}
        <div className="w-full md:w-1/2 relative z-20">
          <h2 className="text-center md:text-left text-3xl sm:text-4xl md:text-5xl font-serif tracking-tight mb-4 sm:mb-6">
            About Me
          </h2>

          {/* Better mobile typography: no manual <br/> layout */}
          <div className="mx-auto md:mx-0 max-w-prose text-center md:text-left space-y-4 sm:space-y-5">
            <p className="text-white/90 text-[15px] sm:text-base leading-7 sm:leading-8 font-light tracking-wide">
              I’m Elijah — a portrait and lifestyle photographer based in California.
            </p>

            <p className="text-white/90 text-[15px] sm:text-base leading-7 sm:leading-8 font-light tracking-wide">
              Whether it’s a couple at the beach or a portrait in the park, my focus is simple:{" "}
              <span className="text-white font-medium">
                strong lighting, clean composition.
              </span>
            </p>

            <p className="text-white/90 text-[15px] sm:text-base leading-7 sm:leading-8 font-light tracking-wide">
              My sessions are relaxed, organized, and easy to be part of. From start to finish,
              you can expect professionalism, smooth communication, and images that hold up long
              after the moment passes.
            </p>

            {/* Callouts */}
            <ul className="pt-2 sm:pt-3 text-xs sm:text-sm text-white/70 font-mono space-y-2">
              <li className="flex items-center justify-center md:justify-start gap-2">
                <span aria-hidden>📍</span>
                <span>Based in California</span>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-2">
                <span aria-hidden>📷</span>
                <span>Shoots on Sony A7 III | 35mm &amp; 70mm</span>
              </li>
              <li className="flex items-center justify-center md:justify-start gap-2">
                <span aria-hidden>🌘</span>
                <span>Favorite time to shoot: blue hour</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;